export default function numberToDayTime(time: number): string {
  const hours = Math.trunc(time / 60);
  const minutes = time % 60;
  return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
}
